import { Component, Input } from '@angular/core';
import { QuoteService } from '../../../core/quote.service';
import { SessionService } from '../../../core/session.service';
import { MessageService } from 'primeng/api';

@Component({
  standalone: false,
  selector: 'app-buy-button',
  template: `
    <span class="buy-container">
      @if (!hideQty) {
        <input type="number" class="qty-input" [(ngModel)]="qty" min="1" />
      }
      <button class="buy-btn" (click)="addToQuote()" [disabled]="adding"
              title="Add to quote">
        <i class="pi pi-shopping-cart"></i> Add
      </button>
    </span>
  `,
  styles: [`
    .buy-container {
      display: inline-flex;
      align-items: center;
      gap: 4px;
    }
    .qty-input {
      width: 50px;
      padding: 3px 6px;
      border: 1px solid #ccc;
      border-radius: 3px;
      font-size: 12px;
      text-align: center;
    }
    .buy-btn {
      padding: 3px 10px;
      background: var(--brand-primary);
      color: #fff;
      border: none;
      border-radius: 3px;
      cursor: pointer;
      font-size: 12px;
      display: inline-flex;
      align-items: center;
      gap: 4px;
    }
    .buy-btn:hover { opacity: 0.85; }
    .buy-btn:disabled { opacity: 0.5; cursor: not-allowed; }
  `]
})
export class BuyButtonComponent {
  @Input() productPartNr = '';
  @Input() hideQty = false;

  qty = 1;
  adding = false;

  constructor(
    private quoteSvc: QuoteService,
    private session: SessionService,
    private messageSvc: MessageService
  ) {}

  addToQuote(): void {
    if (this.adding || !this.productPartNr) return;
    this.adding = true;
    // V1 parity (svc-quotes.js:319-325 / aa-directives.js:443): the active
    // quote id lives on mdViewQuote (defaults to 0 = create new). Going through
    // QuoteService.addSkus reuses the correct dgGet shape (action, returnas:
    // 'BASE', quote_id, data — NOT `skus`) so the server returns the updated
    // quote and we can refresh the header cart in place.
    const qid = this.session.data['mdViewQuote']?.quote_id || '0';
    const skuText = this.productPartNr + ' ' + this.qty;
    this.quoteSvc.addSkus(qid, skuText).subscribe({
      next: (q) => {
        if (q?.quote_id) {
          this.session.data['mdViewQuote'] = q;
        }
        this.messageSvc.add({ severity: 'success', summary: 'Added', detail: `${this.productPartNr} added to quote` });
        this.adding = false;
      },
      error: () => {
        this.messageSvc.add({ severity: 'error', summary: 'Error', detail: 'Failed to add to quote' });
        this.adding = false;
      }
    });
  }
}
